/**
 * Create Conditional State id from Symbol id and Layout id
 *
 * @param symbolId
 * @param layoutId
 */
export const buildConditionalStateId = (symbolId, layoutId) => `${symbolId}_${layoutId}`;
